import { useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Fleet from "../components/Fleet";
import NoDeposit from "../components/NoDeposit";
import HowItWorks from "../components/HowItWorks";
import About from "../components/About";
import Trust from "../components/Trust";
import EnquiryForm from "../components/EnquiryForm";
import Faq from "../components/Faq";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import FloatingContact from "../components/FloatingContact";
import CookieNotice from "../components/CookieNotice";
import VehicleModal from "../components/VehicleModal";
import { scrollToId } from "../constants";

const HomePage = () => {
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [enquiryVehicle, setEnquiryVehicle] = useState(null);
  const [cookiesOpen, setCookiesOpen] = useState(false);

  const handleEnquire = (vehicle) => {
    setSelectedVehicle(null);
    setEnquiryVehicle(vehicle);
    setTimeout(() => scrollToId("enquiry"), 60);
  };

  return (
    <div data-testid="home-page" className="min-h-screen bg-[#08080A]">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Fleet onOpenVehicle={setSelectedVehicle} onEnquire={handleEnquire} />
        <NoDeposit />
        <HowItWorks />
        <About />
        <Trust />
        <EnquiryForm preselected={enquiryVehicle} />
        <Faq />
        <ContactSection />
      </main>
      <Footer onOpenCookies={() => setCookiesOpen(true)} />
      <FloatingContact />
      <CookieNotice forceOpen={cookiesOpen} onClose={() => setCookiesOpen(false)} />
      <VehicleModal vehicle={selectedVehicle} onClose={() => setSelectedVehicle(null)} onEnquire={handleEnquire} />
    </div>
  );
};

export default HomePage;
